import { render, staticRenderFns } from "./ModalEditLocation.vue?vue&type=template&id=28064a32&scoped=true&lang=pug&"
import script from "./ModalEditLocation.vue?vue&type=script&lang=js&"
export * from "./ModalEditLocation.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditLocation.vue?vue&type=style&index=0&id=28064a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28064a32",
  null
  
)

export default component.exports